import React, { useEffect, useState, useMemo } from 'react';
import { toast } from 'react-toastify';
import getReq from '../interface/getRequestinterface';
import { getRequest } from '../request';
import { CacheProvider } from '@emotion/react';
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/system';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Typography, Button } from '@mui/material';
import { KeyboardReturn, Visibility } from '@mui/icons-material';
import Loading from './loading';
import picture from '../css/No-data-amico.svg';


const style={
    formTitle:{
      fontWeight:'bold !important'
    },
    formDescription:{
      color:'#9b9b9b'
    },
    formContainer:{
      padding: '1rem !important',
      border: '3px solid #748DA6',
      backgroundColor: '#f1f7ff59',
      height:'fit-content',
      borderRadius:'0.5rem',
      width:'80%',
      marginBottom:'1rem',
      display:'flex',
      flexDirection:'column'
    },
    titleContainer:{
      padding: '1rem !important',
      border: '3px solid #f37e7b',
      backgroundColor: '#ef9a9a33',
      height:'fit-content',
      borderRadius:'0.5rem',
      width:'80%',
      marginBottom:'1rem'
    },
    container:{
      display:'flex',
      alignItems:'center',
      flexDirection:'column',
    },
    gridBox:{
      display:'grid',
      gridTemplateColumns:'40% 40%',
      columnGap:'5%',
      rowGap:'3%',
      justifyContent:'space-around',
      marginTop:'2rem'
    },
    mobileGridBox:{
      display:'grid',
      gridTemplateColumns:'90%',
      // columnGap:'5%',
      rowGap:'3%',
      justifyContent:'center',
      marginTop:'2rem'
    },
    modalStyle :{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'30rem'
    },
    modalMobileStyle:{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'15rem'
    },
    txtField:{
      width:'100%', 
    },
    headerContainer:{
      display:'flex',
      width:'100%',
      justifyContent:'space-between'
    },
    stateType:{
      fontWeight:'bold'
    },
    title:{
      display:'flex',
      justifyContent:'space-between',
      width:'65rem',
    },
    unShown:{
      visibility:'none'
    }
  }

interface QuestionString{
    question:string;
    answer:number;
    questionId:number;
  }
  interface QuestionList{
    pollformName:string;
    pollformId:number;
    filled:boolean;
    description:string;
    requestCode:number;
    questions:QuestionString[];
  }
function ShowWhoAnswersPoll() {
    const params = useParams();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [questionList, setQuestionList] = useState<Array<QuestionList>>([]);
    const cacheRtl = useMemo(() => {
      return createCache({
        key: "muirtl",
        stylisPlugins: [prefixer, rtlPlugin]
      });
    }, []);
    const getFilledAnswers=async()=>{
        const {data,error}:getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Poll/ShowfilledPollforms/${params.pollformId}`) as getReq;
        if(!error){
            setQuestionList(data.map(x=>({
              pollformName:x.pollformName,
              pollformId:x.pollformId,
              filled:x.filled,
              description:x.description,
              requestCode:x.requestCode,
              questions:x.questions.map(q=>({question:q.question,questionId:q.questionId,answer:q.answer}))
            })));
            setTimeout(() => {
              setIsLoading(true);
            }, 1500);
        }else{
            toast.error(error);
        }
    }
    useEffect(() => {
      getFilledAnswers();
    }, []);
  return (
    <CacheProvider value={cacheRtl}>
      {isLoading?
        <div className={questionList.length?'background':undefined}>
            <Box className="container">
                <div style={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center',height:'100%'}}>
                    {questionList.length?
                    <TableContainer component={Paper} sx={{display:'flex',justifyContent:'center',width:'fit-content'}}>
                        <Table sx={{ width:'65rem' }} aria-label="simple table">
                            <TableHead>
                            <TableRow>
                                <TableCell className='ratesTh' align="center">عنوان نظرسنجی</TableCell>
                                <TableCell className='ratesTh' align="center">شماره درخواست پاسخ دهنده</TableCell>
                                <TableCell className='ratesTh' align="center">نمایش پاسخ ها</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {questionList.map((row,index) => (
                                <TableRow className='ratesTr'
                                key={index}
                                sx={{ '&:last-child , &:last-child': { border: 0 } }}
                                >
                                <TableCell className='ratesTd' align="center">{row.pollformName}</TableCell>                            
                                <TableCell className='ratesTd' align="center">{row.requestCode}</TableCell>                            
                                <TableCell className='ratesTd' align="center">
                                  <Link to='/showFilledForms' state={questionList.filter(x=>x.requestCode === row.requestCode)}>
                                    <IconButton aria-label="" >
                                        <Visibility/>
                                    </IconButton>
                                  </Link>
                                </TableCell>                            
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    :
                    <Box>
                      <img src={picture} alt="" style={{height:'80vh'}}/>
                      <Box sx={{display:'flex',justifyContent:'center'}}>
                      <Button variant="contained" color="secondary" onClick={()=>navigate('/listOfQuestions')}>
                        بازگشت به لیست نظرسنجی<KeyboardReturn/>
                      </Button>
                      </Box>
                    </Box>
                    }
                </div>
            </Box>
        </div>
      :
      <div style={{width:'100vw',height:'calc( 100vh - 64px)',display:'flex',justifyContent:'center',alignItems:'center'}}>
        <Loading type="cylon" color="#000"/>
      </div>
      }
    </CacheProvider>
  )
}

export default ShowWhoAnswersPoll